module.exports = new __parcel__URL__("useravatar.f11816cb.svg").toString();